// extracted by mini-css-extract-plugin
export default {"MyEditDialog":"MyEditDialog_MyEditDialog__TBcAP","photo":"MyEditDialog_photo__FDf4f","containerImage":"MyEditDialog_containerImage__9CoAH"};